import React, { useCallback } from "react";
import { useSnackbar as notistackUseSnackbar } from "notistack";
import OSSSnackMessage from "../OSSSnackMessage/OSSSnackMessage";

const useSnackbar = () => {
  const { enqueueSnackbar: notistackEnqueueSnackbar, closeSnackbar } =
    notistackUseSnackbar();


  /**
   *
   *
   *
   * @typedef {object} EnqueueSnackbarProps
   * @param {string} title
   * @param {string} [message]
   * @param {object} options
   * @param {object} rest
   *
   *
   *
   * @returns {void}
   */
  const enqueueSnackbar = useCallback(
    /**
     *
     * @param {EnqueueSnackbarProps} props
     * @returns
     */
    ({ title, options, ...rest }) =>
      notistackEnqueueSnackbar(title, {
        content: key => (
          <OSSSnackMessage title={title} options={options} {...rest} id={key} />
        ),
        ...options
      }),
    [notistackEnqueueSnackbar]
  );

  return { enqueueSnackbar, closeSnackbar };
};

export default useSnackbar;
